import React from 'react';
import {
  File,
  FileAudio,
  FileCsv,
  FileDoc,
  FileExcel,
  FileImage,
  FilePdf,
  FileVideo,
  Folder,
  FolderOpen,
} from '../../constant/imagePath';

export const IconByExtension = ({ extension }) => {
  const style = { width: '40px', height: '40px', margin: '0 5px' };
  const fileIconMap = {
    folderopen: <img src={FolderOpen} style={style} />,
    folder: <img src={Folder} style={style} />,
    pdf: <img src={FilePdf} style={style} />,
    xlsx: <img src={FileExcel} style={style} />,
    xls: <img src={FileExcel} style={style} />,
    docx: <img src={FileDoc} style={style} />,
    doc: <img src={FileDoc} style={style} />,
    csv: <img src={FileCsv} style={style} />,
    heic: <img src={FileImage} style={style} />,
    heics: <img src={FileImage} style={style} />,
    webp: <img src={FileImage} style={style} />,
    jpg: <img src={FileImage} style={style} />,
    jpeg: <img src={FileImage} style={style} />,
    png: <img src={FileImage} style={style} />,
    gif: <img src={FileImage} style={style} />,
    mp4: <img src={FileVideo} style={style} />,
    avi: <img src={FileVideo} style={style} />,
    mp3: <img src={FileAudio} style={style} />,
  };

  // data-ext lets the new look (v2 Skin) draw its own icon for each type; no effect on its own.
  const key = extension.toLowerCase();
  const kind = fileIconMap[key] ? key : 'file';
  const img = fileIconMap[key] || <img src={File} style={style} />;
  return React.cloneElement(img, { 'data-ext': kind });
};
